'use client'

import { type Table } from '@tanstack/react-table'
import { RefreshCw } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { TaxExemptionItem } from '@/lib/api/taxExemptions'

interface TaxExemptionsTableActionsProps {
	table: Table<TaxExemptionItem>
	onRefresh: () => void
	isLoading: boolean
}

export function TaxExemptionsTableActions({ table, onRefresh, isLoading }: TaxExemptionsTableActionsProps) {
	const { t } = useTranslation('taxes')

	return (
		<div className="flex items-center gap-2">
			<Button variant="outline" size="sm" onClick={onRefresh} disabled={isLoading} className="h-8">
				<RefreshCw className={`mr-2 h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
				{t('refresh')}
			</Button>
		</div>
	)
}
